import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-visibility',
  templateUrl: './visibility.component.html',
  styleUrls: ['./visibility.component.scss'],
})
export class VisibilityComponent {
  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;
  @Input() restrictToRegisteredUsersControl: FormControl<boolean>;
  @Input() notForGoogleNewsSitemapsControl: FormControl<boolean>;
  @Input() notForNewsFeedsControl: FormControl<boolean>;
  @Input() hideThisArticleControl: FormControl<boolean>;
  @Input() paywallPremiumContent: FormControl<boolean>;
  @Input() notForCompetitors: FormControl<boolean>;
}
